<template>
  <div>
    <h2 class="contact-block__title title title-l">Contact us</h2>
    <div class="contact-block__subtitle subtitle subtitle-l">Don't hesitate to contact us, in case you have any further
      questions or comments.
    </div>
    <div class="contact-block__subtitle subtitle subtitle-l" v-if="submitted" style="color: green"> Your message has been successfully sent to us.
    </div>
    <form class="contact-block__form contact-form" @submit.prevent="handleSubmit" novalidate>
      <div class="contact-form__block" :class=" errors.has('name') ? 'invalid' : 'valid'">
        <input class="contact-form__input"
               type="text"
               placeholder="Name"
               name="name"
               v-validate="'required'"
               v-model="name"
               autocomplete="name">
        <svg class="icon icon-name">
          <use xlink:href="#icon-name"></use>
          <symbol id="icon-name" viewBox="0 0 27 32">
            <path d="M13.22 16.892c0.032 0 0.065 0 0.104 0 0.013 0 0.026 0 0.039 0 0.019 0 0.045 0 0.065 0 1.902-0.032 3.441-0.701 4.577-1.98 2.499-2.818 2.084-7.648 2.039-8.109-0.162-3.46-1.798-5.116-3.149-5.888-1.006-0.578-2.181-0.889-3.493-0.915h-0.045c-0.006 0-0.019 0-0.026 0h-0.039c-0.721 0-2.136 0.117-3.493 0.889-1.363 0.773-3.025 2.428-3.188 5.914-0.045 0.461-0.461 5.291 2.039 8.109 1.13 1.279 2.668 1.948 4.57 1.98zM8.344 6.966c0-0.019 0.006-0.039 0.006-0.052 0.214-4.655 3.519-5.155 4.934-5.155h0.026c0.013 0 0.032 0 0.052 0 1.753 0.039 4.733 0.753 4.934 5.155 0 0.019 0 0.039 0.007 0.052 0.007 0.045 0.461 4.46-1.604 6.784-0.818 0.922-1.909 1.376-3.343 1.389-0.013 0-0.019 0-0.032 0s-0.019 0-0.032 0c-1.428-0.013-2.525-0.467-3.337-1.389-2.058-2.311-1.617-6.745-1.61-6.784z"></path>
            <path d="M26.665 24.904c0-0.007 0-0.013 0-0.019 0-0.052-0.007-0.104-0.007-0.162-0.039-1.285-0.123-4.291-2.941-5.252-0.019-0.007-0.045-0.013-0.065-0.019-2.928-0.747-5.363-2.435-5.388-2.454-0.396-0.279-0.941-0.182-1.221 0.214s-0.182 0.941 0.214 1.221c0.11 0.078 2.694 1.876 5.927 2.707 1.513 0.539 1.681 2.155 1.727 3.636 0 0.058 0 0.11 0.007 0.162 0.006 0.584-0.033 1.487-0.136 2.006-1.052 0.597-5.174 2.662-11.446 2.662-6.245 0-10.394-2.071-11.452-2.668-0.104-0.519-0.149-1.422-0.136-2.006 0-0.052 0.006-0.104 0.006-0.162 0.045-1.48 0.214-3.097 1.727-3.635 3.233-0.831 5.817-2.636 5.927-2.707 0.396-0.279 0.493-0.824 0.214-1.22s-0.825-0.493-1.22-0.214c-0.026 0.019-2.448 1.707-5.388 2.454-0.026 0.007-0.045 0.013-0.065 0.019-2.818 0.967-2.902 3.973-2.941 5.252 0 0.058 0 0.11-0.006 0.162 0 0.007 0 0.013 0 0.019-0.006 0.338-0.013 2.071 0.331 2.941 0.065 0.169 0.182 0.312 0.338 0.409 0.195 0.13 4.863 3.103 12.673 3.103s12.478-2.98 12.673-3.103c0.149-0.097 0.273-0.24 0.337-0.409 0.325-0.863 0.318-2.597 0.312-2.934z"></path>
          </symbol>
        </svg>
        <div
            class="invalid-text"
            v-if="errors.has('name')"
        >{{ errors.first('name') }}
        </div>
      </div>
      <div class="contact-form__block" :class=" errors.has('email') ? 'invalid' : 'valid'">
        <input class="contact-form__input"
               name="email"
               v-validate="'required|email'"
               v-model="email"
               type="text"
               placeholder="Email"
               autocomplete="email">
        <svg class="icon icon-email">
          <use xlink:href="#icon-email"></use>
          <symbol id="icon-email" viewBox="0 0 43 32">
            <path d="M36.916 0h-31.774c-2.836 0-5.142 2.306-5.142 5.142v21.716c0 2.836 2.306 5.142 5.142 5.142h31.765c2.836 0 5.142-2.306 5.142-5.142v-21.707c0.009-2.836-2.297-5.151-5.133-5.151zM39.709 26.858c0 1.54-1.253 2.793-2.793 2.793h-31.774c-1.54 0-2.793-1.253-2.793-2.793v-21.707c0-1.54 1.253-2.793 2.793-2.793h31.765c1.54 0 2.793 1.253 2.793 2.793v21.707h0.009z"></path>
            <path d="M26.519 15.73l10.284-9.222c0.479-0.435 0.522-1.175 0.087-1.662-0.435-0.479-1.175-0.522-1.662-0.087l-14.182 12.729-2.767-2.471c-0.009-0.009-0.017-0.017-0.017-0.026-0.061-0.061-0.122-0.113-0.191-0.165l-11.258-10.075c-0.487-0.435-1.227-0.391-1.662 0.096s-0.392 1.227 0.096 1.662l10.406 9.301-10.362 9.701c-0.47 0.444-0.496 1.183-0.052 1.662 0.235 0.244 0.548 0.374 0.861 0.374 0.287 0 0.574-0.104 0.8-0.313l10.519-9.84 2.854 2.549c0.226 0.2 0.505 0.296 0.783 0.296s0.566-0.105 0.783-0.305l2.932-2.628 10.458 9.936c0.226 0.218 0.522 0.322 0.809 0.322 0.313 0 0.618-0.122 0.853-0.366 0.444-0.47 0.426-1.218-0.043-1.662l-10.327-9.805z"></path>
          </symbol>
        </svg>
        <div
            class="invalid-text"
            v-if="errors.has('email')"
        >{{ errors.first('email') }}
        </div>
      </div>
      <div class="contact-form__block" :class=" errors.has('text') ? 'invalid' : 'valid'">
          <textarea class="contact-form__textarea"
                    placeholder="Enter your text"
                    name="text"
                    v-validate="'required'"
                    v-model="text"
                    type="text"
          ></textarea>
        <div
            class="invalid-text"
            v-if="errors.has('text')"
        >{{ errors.first('text') }}
        </div>

      </div>
      <button class="contact-form__btn btn btn-bg" type="submit" >Send a ticket</button>
    </form>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ContactUs',
  data: function () {
    return {
      text: null,
      email: null,
      name: null,
      submitted: false
    }
  },
  computed: {},
  methods: {
    handleSubmit() {
      this.$validator.validateAll().then( async (valid) => {
        if (valid) {
          await this.$recaptchaLoaded()

          const token = await this.$recaptcha('contact_us')
          axios.post('/contact_us.json', {
            name: this.name,
            email: this.email,
            text: this.text,
            "g-recaptcha-response-data": {'contact_us': token }
          })
              .then((response) => {
                this.submitted = true;
                this.name = null;
                this.email = null;
                this.text = null;
                this.errors.clear();
                this.$validator.reset();
              })
              .catch(function (error) {
                console.log('Error! Could not reach the API. ' + error)
              })
        } else {
          console.log("Invalid form");
        }
      });
    }
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.contact-form__block .icon-name {
  width: 20px;
  height: 24px;
}
</style>